import { memo } from "react";

/**
 * Visual break between two channel threads on the same support ticket.
 *
 * In the v2 topic-span model, one ticket can accumulate multiple threads
 * (e.g., a customer who started on email and escalated to SMS — the topic
 * is linked to both lanes via `topic_channel_thread`). This divider sits
 * between consecutive threads in `support-ticket-view.tsx` so the eye has a
 * clear seam; the next thread's `ThreadHeader` then names the channel,
 * subject, and most-recent-message time.
 *
 * No "merged" framing — multi-thread is the natural shape of a topic, not
 * a special merge result. (The v1 model had one thread per ticket, so
 * multi-thread there meant an explicit merge action; in v2 it does not.)
 */
export const ThreadBoundaryDivider = memo(function ThreadBoundaryDivider() {
  return (
    <div
      style={{
        width: "100%",
        height: 1,
        margin: "12px 0",
        backgroundColor: "var(--redo-colors-border-border-secondary, #e5e5e5)",
      }}
    />
  );
});
